import React, { useEffect } from "react";
import { HalloweenSpooks } from "./HalloweenSpooks";
import { useHolidayTheme } from "@/hooks/useHolidayTheme";
import "@/styles/seasonal.css";

export const HalloweenThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isHalloween } = useHolidayTheme();

  useEffect(() => {
    if (isHalloween) {
      document.body.classList.add("halloween-theme");
      document.documentElement.style.setProperty("--seasonal-accent", "25 95% 53%");
      document.documentElement.style.setProperty("--seasonal-glow", "25 95% 53% / 0.3");
    } else {
      document.body.classList.remove("halloween-theme");
      document.documentElement.style.removeProperty("--seasonal-accent");
      document.documentElement.style.removeProperty("--seasonal-glow");
    }

    return () => {
      document.body.classList.remove("halloween-theme");
      document.documentElement.style.removeProperty("--seasonal-accent");
      document.documentElement.style.removeProperty("--seasonal-glow");
    };
  }, [isHalloween]);

  return (
    <>
      {isHalloween && <HalloweenSpooks count={28} />}
      {children}
    </>
  );
};

export default HalloweenThemeProvider;
